<!-- src/components/graph-sub-contents/graph-output-prediction.vue -->
<template>
  <div class="chart-wrap">
    <!-- 生産金額（上） -->
    <div class="chart-block">
      <div class="chart-title">生産金額</div>
      <GChart
        :type="'ColumnChart'"
        :data="chartDataAmount"
        :options="chartOptionsAmount"
        :resizeDebounce="50"
      />
    </div>

    <!-- 軟体部重量（下） -->
    <div class="chart-block">
      <div class="chart-title">軟体部重量</div>
      <GChart
        :type="'LineChart'"
        :data="chartDataWeight"
        :options="chartOptionsWeight"
        :resizeDebounce="50"
      />
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  name: "GraphOutputPrediction",
  components: { GChart },

  props: {
    /** 生産金額（棒）：[{ day: 0, val: 300 }, ...] or {0:{},1:{},...} */
    amountData:  { type: [Array, Object], required: true },
    /** Ww と SD（折線）：[{ day: 0, ww: 12.0, sd: 4.0 }, ...] or {0:{},...} */
    weightData:  { type: [Array, Object], required: true },
    /** 互換用（未使用）: 旧タブ初期モード */
    defaultMode: { type: String, default: "amount" },
  },

  computed: {
    // ---- データ整形：金額 ----
    amountRows() {
      const src = Array.isArray(this.amountData)
        ? this.amountData
        : Object.values(this.amountData);
      return src
        .filter(r => r && r.day !== undefined && r.val !== undefined)
        .sort((a, b) => a.day - b.day)
        .map(r => [String(r.day), Number(r.val)]);
    },

    // ---- データ整形：重量 ----
    weightRows() {
      const src = Array.isArray(this.weightData)
        ? this.weightData
        : Object.values(this.weightData);
      const sorted = src
        .filter(r => r && r.day !== undefined && r.ww !== undefined && r.sd !== undefined)
        .sort((a, b) => a.day - b.day);

      const lastIdx = sorted.length - 1;

      return sorted.map((r, i) => {
        const ww = Number(r.ww);
        const sd = Number(r.sd);
        const plus = ww + sd;
        const minus = ww - sd;

        // 注釈（先頭：初期値 / 末尾：予測値）
        let ann = null;
        let annText = null;
        if (i === 0) {
          ann = "初期値";
          annText = `${ww.toFixed(1)} ± ${sd.toFixed(1)}`;
        } else if (i === lastIdx) {
          ann = "予測値";
          annText = `${ww.toFixed(1)} ± ${sd.toFixed(1)}`;
        }

        // [x, Ww, annotation, annotationText, +SD, -SD]
        return [String(r.day), ww, ann, annText, plus, minus];
      });
    },

    // ---- グラフデータ ----
    chartDataAmount() {
      return [["日付", "生産金額（万円/筏）"], ...this.amountRows];
    },
    chartDataWeight() {
      return [
        ["日付", "平均軟体部重量（予測値）", { role: "annotation" }, { role: "annotationText" }, "+SD", "-SD"],
        ...this.weightRows,
      ];
    },

    // ---- オプション（縦軸は自動スケール） ----
    chartOptionsAmount() {
      return {
        legend: { position: "none" },
        height: 320,
        bar: { groupWidth: "60%" },
        colors: ["#3b82f6"],
        chartArea: { left: 60, right: 20, top: 20, bottom: 50, width: "100%", height: "75%" },
        hAxis: { showTextEvery: 1, textStyle: { fontSize: 11 } },
        vAxis: {
          title: "生産金額（万円/筏）",
          minValue: 0,
          viewWindowMode: "pretty",
          gridlines: { count: 5, color: "#eeeeee" },
        },
      };
    },

    chartOptionsWeight() {
      return {
        height: 340,
        legend: { position: "bottom" },
        pointSize: 4,
        series: {
          0: { lineWidth: 2 },          // Ww
          1: { lineDashStyle: [6, 3] }, // +SD
          2: { lineDashStyle: [6, 3] }, // -SD
        },
        annotations: {
          style: "box",
          stem: { length: 14, color: "#333" },
          textStyle: { fontSize: 12, bold: true, color: "#111" },
          boxStyle: { stroke: "#333", strokeWidth: 1, rx: 4, ry: 4, gradient: null },
        },
        chartArea: { left: 70, right: 20, top: 10, bottom: 50, width: "100%", height: "75%" },
        hAxis: { showTextEvery: 1, textStyle: { fontSize: 11 } },
        vAxis: {
          title: "軟体部重量 (g)",
          minValue: 0,
          viewWindowMode: "pretty",
          gridlines: { count: 5, color: "#eeeeee" },
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-wrap {
  width: 100%;
  max-width: 900px;
  margin: 0 auto; /* 中央寄せ */
}
.chart-block {
  margin: 16px 0 28px;
}
.chart-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 4px;
}
</style>
